<script setup lang="ts">
import type { Partner, PartnerParameter } from '@/types/types'

const { t } = useI18n()
const props = withDefaults(
  defineProps<{
    selectedPartner: Partner
    partnerParameters: PartnerParameter[]
  }>(),
  {
    partnerParameters: () => []
  }
)

const emit = defineEmits<(e: 'onPartnerParameterSelected', partnerParameterId: number) => void>()
const radioValue = ref(null)
const radioGroup = computed(() => {
  return props.partnerParameters.map((partnerParameter) => ({
    id: partnerParameter.id,
    img: partnerParameter.partner.logo,
    title: t(`pages.marketplace.tabletsPage.partnerParameterAccountName`, {
      partnerName: partnerParameter.partner.name,
      accountName: partnerParameter.publicId
    })
  }))
})

watchEffect(() => {
  if (radioValue.value) {
    emit('onPartnerParameterSelected', radioValue.value)
  }
})
</script>

<template>
  <h3 class="mb-3 text-left text-sm font-medium">{{ t('pages.tablet.partnerSelectorTitle') }}</h3>
  <div v-if="selectedPartner" class="my-4 text-left text-sm">
    <BaseTip
      severity="success"
      :text="t('pages.marketplace.tabletsPage.tabletSelector.associated')"
      :img="selectedPartner.logo"
    />
  </div>
  <AppRadioCard v-model="radioValue" class="grid gap-3 sm:grid-cols-2" :options="radioGroup.map((item) => item.id)">
    <template v-for="(item, index) in radioGroup" #[index] :key="index">
      <div class="flex items-center space-x-4 text-sm font-medium text-foreground">
        <img :src="radioGroup[index].img" class="h-10 w-10" />
        <label class="hover:cursor-pointer">{{ radioGroup[index].title }}</label>
      </div>
    </template>
  </AppRadioCard>
</template>
